document.addEventListener('DOMContentLoaded', () => {
  const $root = $('.employee-form')

  if (!$root.length) {
    return
  }

  const updateRoleFields = () => {
    const currentRole = $root.find('input[name="employee[role]"]:checked').val()

    $root.find('.employee-form__affiliate-settings').toggle(currentRole === 'affiliate')

    $root.find('.employee-form__staff-settings').toggle(currentRole === 'staff')
  }

  updateRoleFields()

  $root.on('change', 'input[name="employee[role]"]', updateRoleFields)
})
